import {
  Card,
  CardContent,
  CardHeader,
  Fab,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useFieldArray } from "react-hook-form";
import {
  OstaliIdentifikatoriDrzavaIzdavatelj,
  OstaliIdentifikatoriIdentifikacijskiBroj,
  OstaliIdentifikatoriVrstaIdentifikatora,
} from "../../../index";
import { useEffect } from "react";

const Index = ({
  nazivPolja,
  naslov,
  oIObavezan,
}: {
  nazivPolja: string;
  naslov?: string;
  oIObavezan?: boolean;
}) => {
  const { fields, append, remove, update } = useFieldArray({
    name: nazivPolja,
    keyName: "key",
  });
  const dodajIdentifikator = (index: number) => {
    append({
      vrstaIdentifikatora: { id: undefined },
      drzavaIzdavatelj: { oznaka: "" },
    });
  };

  const ukloniIdentifikator = (index: number) => {
    remove(index);
  };

  return (
    <Card
      variant={"outlined"}
      sx={{ mt: 3, position: "relative" }}
      className={fields.length <= 0 ? "root-p-0" : ""}
    >
      <CardHeader
        title={naslov || "Ostali identifikatori (Other identifiers)"}
        titleTypographyProps={{ variant: "h6" }}
        action={
          <Tooltip title={"Dodaj (Add)"}>
            <Fab
              size={"small"}
              aria-label="settings"
              onClick={() => dodajIdentifikator(fields.length)}
              disabled={fields.length >= 10}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        }
      ></CardHeader>
      <CardContent>
        {fields.map((field: any, index) => (
          <Card
            variant={"outlined"}
            sx={{ mt: 3, position: "relative" }}
            key={index}
          >
            <CardHeader
              title={`Identifikator (Identifier) ${index + 1}`}
              titleTypographyProps={{ variant: "h6" }}
              action={
                <Tooltip title={"Ukloni (Remove)"}>
                  <IconButton
                    aria-label="settings"
                    sx={{ marginTop: "8px" }}
                    onClick={() => ukloniIdentifikator(index)}
                    disabled={oIObavezan ? fields.length <= 1 : false}
                  >
                    <RemoveIcon />
                  </IconButton>
                </Tooltip>
              }
            ></CardHeader>
            <CardContent>
              <Grid container spacing={2} key={field.id}>
                <Grid item xs={4}>
                  <OstaliIdentifikatoriVrstaIdentifikatora
                    field={field}
                    index={index}
                    update={update}
                    nazivPolja={`${nazivPolja}[${index}].vrstaIdentifikatora`}
                  />
                </Grid>
                <Grid item xs={4}>
                  <OstaliIdentifikatoriDrzavaIzdavatelj
                    field={field}
                    index={index}
                    update={update}
                    nazivPolja={`${nazivPolja}[${index}].drzavaIzdavatelj`}
                  />
                </Grid>
                <Grid item xs={4}>
                  <OstaliIdentifikatoriIdentifikacijskiBroj
                    field={field}
                    index={index}
                    update={update}
                    nazivPolja={`${nazivPolja}[${index}].identifikacijskiBroj`}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
};

export default Index;
